module.exports = __webpack_public_path__ + "static/media/overcast.bd652b9e.svg";